import { StockOperationType } from '@teinor/erp/types/company/product/stockParent/stockHistory'
import { StockReservedStatus } from '@teinor/erp/types/company/product/stockParent/stockReservedHistory'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { RowData } from '../../../baseComponents/TwinTable/types'
import { CustomRenderStringTwoLinesTooltip } from '../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { TwinDictionary } from '../../../utils/globals/dictionary'
import locations from '../../../utils/globals/locations'
import TwinIcon from '../../../baseComponents/TwinIcon'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'

interface CustomRenderStockProps {
    allRowData: RowData
}

export const CustomRenderStock: React.FC<CustomRenderStockProps> = ({ allRowData }) => {
    if (!allRowData?.StockHistorys?.length) {
        return <div>0</div>
    }
    return <div>{allRowData.StockHistorys[allRowData.StockHistorys?.length - 1].currentStock}</div>
}

export const CustomRenderStockReserved: React.FC<CustomRenderStockProps> = ({ allRowData }) => {
    if (!allRowData?.StockReservedHistorys?.length) {
        return <div>0</div>
    }
    return <div>{allRowData.StockReservedHistorys[allRowData.StockReservedHistorys?.length - 1].currentStock}</div>
}

interface CustomRenderStockOperationTypeProps {
    value: StockOperationType
}

export const CustomRenderStockOperationType: React.FC<CustomRenderStockOperationTypeProps> = ({ value }) => {
    const { t } = useTwinTranslation()
    const jsonTrans = {
        'sell': t('sell', 'Venta'),
        'buyOrder': t('buyOrderL', 'Pedido de Compra'),
        'buyDeliveryNote': t('buyDeliveryNote', 'Albarán de Compra'),
        'buyInvoice': t('buyInvoice', 'Factura de Compra'),
        'sellOrder': t('sellOrder', 'Pedido de Venta'),
        'sellDeliveryNote': t('sellDeliveryNote', 'Albarán de Venta'),
        'sellInvoice': t('selInvoice', 'Factura de Venta'),
        'sendToOtherWarehouse': t('sendToOtherWarehouse', 'Enviado a otro Almacén'),
        'recieveFromOtherWarehouse': t('recieveFromOtherWarehouse', 'Recibido de otro Almacén'),
        'changedInvoicePrice': t('changedInvoicePrice', 'Cambiado precio de stock'),
        'buyRefundDeliveryNote': t('buyRefundDeliveryNote', 'Devolución albarán de compra'),
        'buyRefundInvoice': t('buyRefundInvoice', 'Devolución factura de compra'),
        'sellRefundDeliveryNote': t('sellRefundDeliveryNoteShort', 'Dev. albarán de venta'),
        'sellRefundInvoice': t('sellRefundInvoiceShort', 'Dev. factura de venta'),
        'changedRefundInvoicePrice': t('changedRefundInvoicePrice', 'Cambio precio por devolución de factura'),
        'stockMaterial': t('stockMaterialL', 'Depósito de material'),
        'sellTicket': t('ticket', 'Ticket'),
        'sellRefundTicket': t('ticketRefund', 'Dev. ticket de venta'),
        'adjustmentDeliveryNote': t('adjustmentDeliveryNote', 'Albarán de regularización'),
        'manufacturingPDF': ''
    }

    return (
        <div className={'flex items-center w-full'}>
            {jsonTrans[value]}
        </div>
    )
}
interface CustomRenderStockReserveTypeProps {
    value: keyof StockReservedStatus
}

export const CustomRenderStockReserveType: React.FC<CustomRenderStockReserveTypeProps> = ({ value }) => {
    const { t } = useTwinTranslation()
    const jsonTrans = {
        0: t('reservedM', 'Reservado'),
        1: t('served', 'Servido'),
        2: t('waitingPickUp', 'Esperando recogida'),
        3: t('served', 'Servido'),
        4: t('canceled', ' Cancelado')
    }

    return (
        <div className={'flex items-center w-full'}>
            {jsonTrans[value]}
        </div>
    )
}

interface CustomRenderProductStockHistoryProps {
    id: string
    name: string
    unique_number?: string
}

export const CustomRenderProductStockHistory: React.FC<CustomRenderProductStockHistoryProps> = ({ id, name, unique_number }) => {
    return (
        <CustomRenderStringTwoLinesTooltip value={(unique_number ? unique_number : name)} id={id} />
    )
}


interface ButtonToOrderProps {
    id: string
    operationType: string
}

export const ButtonToOrder: React.FC<ButtonToOrderProps> = ({ id, operationType }) => {
    const dictUrl: TwinDictionary = {
        'sellDeliveryNote': { url: locations.sellDeliveryNoteSingle + '/' + id },
        'sellInvoice': { url: locations.sellInvoiceSingle + '/' + id },
        'buyDeliveryNote': { url: locations.buyDeliveryNoteSingle + '/' + id },
        'buyInvoice': { url: locations.buyInvoiceSingle + '/' + id },
        'sellRefundInvoice': { url: locations.sellInvoiceRefundSingle + '/' + id },
        'sellTicket': { url: locations.sellTicketSingle + '/' + id },
        'adjustmentDeliveryNote': { url: locations.adjustmentDeliveryNoteSingle + '/' + id },
    }
    return (
        <a href={dictUrl[operationType]?.url || ''} target='_blank' rel="noreferrer">
            <div className='pl-20 pr-10'>
                <TwinIcon icon={faChevronRight} />
            </div>
        </a>
    )
}